import script from "./CommentReplyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentReplyButton.vue?vue&type=script&setup=true&lang=js"

import "./CommentReplyButton.vue?vue&type=style&index=0&id=53291588&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53291588"]])

export default __exports__